import {SortDirection} from "@renta-apps/athenaeum-toolkit";

export default class ListWorkOrderStatusesRequest {
    public workOrderId: string = "";

    public pageNumber: number = 1;

    public pageSize: number = 100;
    
    public sortColumnName: string | null = null;

    public sortDirection: SortDirection | null = null;
}